import React, { useMemo } from 'react'
import { Box, FormLabel } from '@mui/material'
import { useField } from 'formik'
import { useAppTranslations } from '../../../utils/hooks/useAppTranslations'
import { LocationTypesEnum } from '../../../pages/adgroup/settings/geoTargeting/GeoTargetingFields'
import { AutoCompleteGoogleMapFieldProps } from './intefaces'
import GeoLocationChipList from './GeoLocationChipList'

type ReadOnlyGeoLocationsListProps = Pick<AutoCompleteGoogleMapFieldProps, 'name' | 'label' | 'locationType'>

const ReadOnlyGeoLocationsList: React.FC<ReadOnlyGeoLocationsListProps> = ({
  name,
  label,
  locationType = LocationTypesEnum.Cities,
}) => {
  const t = useAppTranslations()
  const [field] = useField({ name })
  const value = useMemo(() => (Array.isArray(field.value) ? field.value : []), [field.value])

  return (
    <Box>
      <FormLabel sx={{ textTransform: 'uppercase', fontSize: '1.05rem' }}>{t(label)}</FormLabel>
      <GeoLocationChipList locations={value} locationType={locationType} fieldName={name} readOnly />
    </Box>
  )
}

export default ReadOnlyGeoLocationsList
